async function request(_fetch, url, verb, headers, body, log, fallback) {
  try {
    headers = headers ? headers : {}
    headers['Accept'] = 'application/json'
    headers['Content-Type'] = 'application/json'

    let options = {
      method: verb,
      headers: headers
    }

    if(body) {
      options.body = JSON.stringify(body)
    }

    const res = await _fetch(url, options)
    if (!res.ok) {
      throw new Error('error', {cause: res})
    }

    return res.json()
  } catch (error) {
    log(error)
    return fallback
  }
}

function initGet({_fetch, _log}){
  return async (url, headers, fallback) => {
    return request(_fetch, url, 'GET', headers, null, _log, fallback)
  }
}

function initPost({_fetch, _log}){
  return async (url, headers, body, fallback) => {
    return request(_fetch, url, 'POST', headers, body, _log, fallback)
  }
}

function initPut({_fetch, _log}){
  return async (url, headers, body, fallback) => {
    return request(_fetch, url, 'PUT', headers, body, _log, fallback)
  }
}

function initPatch({_fetch, _log}){
  return async (url, headers, body, fallback) => {
    return request(_fetch, url, 'PATCH', headers, body, _log, fallback)
  }
}

export {
  initGet,
  initPost,
  initPut,
  initPatch
}
